export default {
  name: 'progressBar',
  component(props) {
    const { value, textTo, textReached } = props
    return {
      utmDiscountActive: false,
      discountSession: null as { threshold: string; productName: string } | null,
      title: '',
      threshold: 0,
      productName: '',
      percent: 0,
      init() {
        const utmDiscount = sessionStorage.getItem('UTM_discount')
        if (utmDiscount) {
          this.utmDiscountActive = true
          this.discountSession = JSON.parse(utmDiscount)
        } else {
          this.utmDiscountActive = false
          this.discountSession = null
        }

        this.updateProgress()
      },
      updateProgress() {
        if (this.discountSession) {
          this.threshold = parseFloat(this.discountSession?.threshold) || 0
          this.productName = this.discountSession?.productName || ''

          const percentFreeProduct = (value / this.threshold) * 100
          this.percent = Math.min(percentFreeProduct, 100)

          if (percentFreeProduct >= 100) {
            this.title = textReached.replace('{{product}}', this.productName)
          } else {
            const delta = (this.threshold - value) * 100
            this.title = textTo
              .replace(
                '{{money}}',
                new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(delta / 100)
              )
              .replace('{{product}}', this.productName)
          }
        }
      }
    }
  }
}
